import React, { useState, useEffect, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import Tooltip from '@material-ui/core/Tooltip';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import DeleteIcon from '@material-ui/icons/Delete';
import { handleSnackBar, setReRender } from '../../../store/global/actions';
import { tableTdIconStyles } from "../../../config/styles";
import DeleteEventAlert from "../alerts/DeleteEventAlert";
import { constructIds } from '../../../config/common';
import { StyledTableCell, StyledTableRow } from '../../atoms/table/tableStyles';
import Hyperlink from '../../atoms/links/Hyperlink';
import { SearchTextField } from '../blueprint/SearchField';
import { stableSort, getComparator } from '../../../services/entities/common';
import { StyledTableCellHead } from '../../atoms/table/tableStyles';
import { invokeGetService } from '../../../store/global/actions'

export default function AllEvents({ element }) {
    const dispatch = useDispatch();
    const [allEvents, setAllEvents] = useState([]);
    const [messages, setMessages] = useState([]);
    const [clusterlets, setClusterlets] = useState([]);
    const [deleteEventId, setDeleteEventId] = useState(null);
    const [transId, setTransId] = useState('');
    const [loading, setLoading] = useState(false);
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredEvents, setFilteredEvents] = useState([]);

    const modifyAllEvents = ({events, transactions, clusterlets, messages}) => {
        let newEvents = []
        events?.forEach(event => {
            let obj = {event}

            transactions?.forEach(transaction => {
                transaction.events.forEach(ele => {
                    if (ele.id == event?._id) {
                        obj.transaction = transaction;
                    }
                })
            })

            let message = messages.find(item => item?._id === event.message)
            if(message != undefined){
                obj.message = message
            }

            let source = clusterlets.find(item => item?._id === event.src)
            if(source != undefined){
                obj.source = source
            }

            let target = clusterlets.find(item => item?._id === event.dst)
            if(target != undefined){
                obj.target = target
            }

            newEvents.push(obj);
        });

        
        return newEvents;
    }

    const fetchEvents = () => {
        setLoading(true);
        dispatch(invokeGetService('getClusterletAssocitedEvents', [element.id, 1])).then(res => {
            if (res?.status) {
                setClusterlets(res?.data?.clusterlets);
                setMessages(res?.data?.messages);

                let modifiedEvents = modifyAllEvents({
                    events: res?.data?.events,
                    transactions: res?.data?.transactions,
                    clusterlets: res?.data?.clusterlets,
                    messages: res?.data?.messages
                })

                setAllEvents(modifiedEvents);
                setFilteredEvents(modifiedEvents);

            }
            setLoading(false);
        })
    }

    useEffect(() => {
        fetchEvents();
    }, [element]);


    useEffect(() => {
        setFilteredEvents(allEvents.filter(row => {
            const eventName = row.event?.name?.toLowerCase() ?? '';
            const messageName = messages.find(el => el?._id === row.event?.message)?.name?.toLowerCase() ?? '';
            const transactionName = row?.transaction?.name?.toLowerCase() ?? '';
            const srcName = clusterlets.find(e => e?._id === row.event?.src)?.name?.toLowerCase() ?? '';
            const dstName = clusterlets.find(e => e?._id === row.event?.dst)?.name?.toLowerCase() ?? '';
    
            const query = searchQuery.toLowerCase();
    
            return (
                eventName.includes(query) ||
                messageName.includes(query) ||
                transactionName.includes(query) ||
                srcName.includes(query) ||
                dstName.includes(query)
            );
        }));
    }, [searchQuery]);

    const onClose = () => {
        setDeleteEventId(null)
    }

    const onCompletion = () => {
        fetchEvents();
        setDeleteEventId(null)
        dispatch(setReRender());
        dispatch(handleSnackBar({ open: true, message: 'Event deleted', severity: 'success' }));
    }

    console.log({filteredEvents})
    return (
        <>
            <SearchTextField setSearchQuery={setSearchQuery} searchQuery={searchQuery} />

            <TableContainer component={Paper} style={{borderRadius: "0", boxShadow: 'none'}}>
                <Table aria-label="customized table" id="events_table">
                    <TableHead>
                        <TableRow >
                            <StyledTableCellHead align='left' orderBy={orderBy} order={order} setOrderBy={setOrderBy} setOrder={setOrder} sortName={'event.name'}> Event Name</StyledTableCellHead>
                            <StyledTableCellHead align='left' orderBy={orderBy} order={order} setOrderBy={setOrderBy} setOrder={setOrder} sortName={'message.name'} > Event Type </StyledTableCellHead>
                            <StyledTableCellHead align='left' orderBy={orderBy} order={order} setOrderBy={setOrderBy} setOrder={setOrder} sortName={'transaction.name'}> Transaction </StyledTableCellHead>
                            <StyledTableCellHead align='left' orderBy={orderBy} order={order} setOrderBy={setOrderBy} setOrder={setOrder} sortName={'source.name'}> Source </StyledTableCellHead>
                            <StyledTableCellHead align='left' orderBy={orderBy} order={order} setOrderBy={setOrderBy} setOrder={setOrder} sortName={'target.name'}> Target </StyledTableCellHead>
                            <StyledTableCellHead align='right' isHeader> Action   </StyledTableCellHead>
                        </TableRow>
                    </TableHead>
                    <TableBody>

                        {loading ?
                            <StyledTableRow>
                                <StyledTableCell align={'center'} colSpan={7} component="td" style={{ padding: 15 }}>
                                    Loading... <CircularProgress size={15} style={{ color: '#000' }} />
                                </StyledTableCell>
                            </StyledTableRow>
                        : filteredEvents.length < 1 ?
                                <StyledTableRow>
                                    <StyledTableCell align={'center'} colSpan={7} component="td" style={{ padding: 15 }}>
                                        No events available.
                                    </StyledTableCell>
                                </StyledTableRow>

                        : stableSort(filteredEvents, getComparator(order, orderBy))?.map((item, index) => (
                            
                                <StyledTableRow key={item?.event?._id} >

                                    {/* Event */}
                                    <StyledTableCell align={'left'} component="td" >
                                        <Hyperlink id={item?.event?._id} item={item?.event} name={item?.event?.name} transactionId={item?.transaction?._id} type={'event'} screen={'transaction'} protocol={clusterlets.find(e => e?._id === item?.event?.src)?.attributes?.type ? clusterlets.find(e => e?._id === item?.event?.src)?.attributes?.type : clusterlets.find(e => e?._id === item?.event?.dst)?.attributes?.type ? clusterlets.find(e => e?._id === item?.event?.dst)?.attributes?.type : null}>{item?.event?.name}</Hyperlink>
                                    </StyledTableCell>

                                    {/* Event type */}
                                    <StyledTableCell align={'left'} component="td" >
                                        <Hyperlink id={item?.event?._id} item={item?.event} name={item?.event?.name} transactionId={item?.transaction?._id} type={'event'} screen={'transaction'} protocol={clusterlets.find(e => e?._id === item?.event?.src)?.attributes?.type ? clusterlets.find(e => e?._id === item?.event?.src)?.attributes?.type : clusterlets.find(e => e?._id === item?.event?.dst)?.attributes?.type ? clusterlets.find(e => e?._id === item?.event?.dst)?.attributes?.type : null}  tab={1}> {messages.find(element => element?._id === item?.event?.message)?.name ? messages.find(element => element?._id === item?.event?.message)?.name : ""} </Hyperlink>
                                    </StyledTableCell>

                                    {/* Transaction name */}
                                    <StyledTableCell align={'left'} component="td" >
                                        <Hyperlink id={item?.transaction?._id} transactionId={item?.transaction?._id} name={item?.transaction?.name} type={'transaction'} screen={'transaction'} > {item?.transaction?.name} </Hyperlink>
                                    </StyledTableCell>

                                    {/* Source of event */}
                                    <StyledTableCell align={'left'} component="td" >
                                        {item?.event?.src === element?.id && clusterlets.find(e => e?._id === item?.event?.src)?.name}
                                        {item?.event?.dst === element?.id && <Hyperlink id={item?.event?.src} type={constructIds.find(element => element?.id === clusterlets.find(e => e?._id === item?.event?.src)?.type)?.type} protocol={clusterlets.find(e => e?._id === item?.event?.src)?.attributes?.type} name={clusterlets.find(e => e?._id === item?.event?.src)?.name} desc={clusterlets.find(e => e?._id === item?.event?.src)?.attributes?.desc}>  {clusterlets.find(e => e?._id === item?.event?.src)?.name}  </Hyperlink>}
                                    </StyledTableCell>

                                    {/* Torget of the event */}
                                    <StyledTableCell align={'left'} component="td" >
                                        {item?.event?.dst === element?.id && clusterlets.find(e => e?._id === item?.event?.dst)?.name}
                                        {item?.event?.src === element?.id && <Hyperlink id={item?.event?.dst} type={constructIds.find(element => element?.id === clusterlets.find(e => e?._id === item?.event?.dst)?.type)?.type} protocol={clusterlets.find(e => e?._id === item?.event?.dst)?.attributes?.type} name={clusterlets.find(e => e?._id === item?.event?.dst)?.name} desc={clusterlets.find(e => e?._id === item?.event?.dst)?.attributes?.desc}>  {clusterlets.find(e => e?._id === item?.event?.dst)?.name}  </Hyperlink>}
                                    </StyledTableCell>

                                    {/* Actions */}
                                    <StyledTableCell align={'right'}>
                                        <Tooltip title="Delete event">
                                            <IconButton aria-label="more" size='small' aria-haspopup="true" onClick={() => { setDeleteEventId(item?.event?._id); setTransId(item?.transaction?._id) }}>
                                                <DeleteIcon style={tableTdIconStyles} color="error" />
                                            </IconButton>
                                        </Tooltip>
                                    </StyledTableCell>

                                </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {deleteEventId && <DeleteEventAlert eventId={deleteEventId} onClose={onClose} onCompletion={onCompletion} parentTransactionId={transId} />}
        </>
    )
}